import {
  Column,
  InspectionModelViewSchema,
  InspectionViewSchema,
} from '@fsf/types';
import { _ } from '@ngx-translate/core';
import * as z from 'zod';

const InspectionItemSchema = InspectionModelViewSchema.extend({
  type: z.string(),
  item_id: z.string(),
  checked_at: z.string().nullable(),
});

export type InspectionItem = z.infer<typeof InspectionItemSchema>;

const InspectionSchema = InspectionViewSchema.extend({
  id: z.any(),
  status: z.number(),
  models: z.array(InspectionItemSchema),
  created_at: z.string(),
  deleted_at: z.string().nullable(),
  updated_at: z.string().nullable(),
});

export type Inspection = z.infer<typeof InspectionSchema>;

const inspectionColumns: Column<keyof Inspection>[] = [
  {
    header: 'inspection.name',
    field: 'name',
    filterField: 'name',
    sortField: 'name',
    type: 'text',
    displayType: 'text',
    showOperator: false,
    showMatchModes: false,
    showAddButton: false,
  },
  {
    header: 'inspection.date',
    field: 'date',
    filterField: 'date',
    sortField: 'date',
    type: 'date',
    displayType: 'date',
    matchMode: 'between',
    showOperator: false,
    showMatchModes: false,
    showAddButton: false,
  },
  {
    header: 'inspection.status',
    field: 'status',
    filterField: 'status',
    sortField: 'status',
    type: 'numeric',
    displayType: 'progress',
    showOperator: false,
    showMatchModes: true,
    showAddButton: false,
  },
];

const inspectionItemColumns: Column<keyof InspectionItem>[] = [
  {
    header: 'inspectionItem.name',
    field: 'name',
    sortField: 'name',
    type: 'text',
    displayType: 'text',
    showOperator: false,
    showMatchModes: false,
    showAddButton: false,
  },
  {
    header: 'inspectionItem.sectionType',
    field: 'section_type',
    sortField: 'section_type',
    type: 'text',
    displayType: 'text',
    showOperator: false,
    showMatchModes: false,
    showAddButton: false,
  },
  {
    header: 'inspectionItem.itemId',
    field: 'item_id',
    sortField: 'item_id',
    type: 'text',
    displayType: 'text',
    showOperator: false,
    showMatchModes: false,
    showAddButton: false,
  },
  {
    header: 'inspectionItem.checkedAt',
    field: 'checked_at',
    sortField: 'checked_at',
    type: 'date',
    displayType: 'date',
    showOperator: false,
    showMatchModes: false,
    showAddButton: false,
  },
];

const globalFilterFields = ['name'];

export const InspectionMetadata = {
  inspectionColumns,
  globalFilterFields,
};
export const InspectionItemMetadata = {
  inspectionItemColumns,
  globalFilterFields,
};

export const inspectionTranslations = _([
  'inspection.name',
  'inspection.date',
  'inspection.status',
  'inspectionItem.name',
  'inspectionItem.sectionType',
  'inspectionItem.sectionTypeElement',
  'inspectionItem.sectionTypePlatform',
  'inspectionItem.itemId',
  'inspectionItem.checkedAt',
]);

// Input schemas (→ StoreInspectionRequest / UpdateInspectionRequest)
export const StoreInspectionSchema = z.object({
  name: z.string().min(1).max(255),
  date: z.union([z.string().min(1), z.date()]),
});
export const UpdateInspectionSchema = StoreInspectionSchema.partial();
